import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as GlobeIcon} from '../../assets/icons/globe.svg';
import {LanguageDropdown, LanguageLabel, LanguageOption, LanguageSwitcherContainer} from './LanguageSwitcher.styled';
import {languages} from "../../config/languages";
import {Tooltip} from "@mui/material";

interface LanguageSwitcherProps {
    languageList: typeof languages;
}

const LanguageSwitcher= (props: LanguageSwitcherProps) => {
    const {t} = useTranslation();
    const {i18n} = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const currentLanguage = i18n.language;

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        };

        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);


    const handleLanguageChange = (languageCode: string) => {
        i18n.changeLanguage(languageCode);
        localStorage.setItem('language', languageCode);
        setIsDropdownOpen(false);
    };

    const getCurrentLanguageLabel = () => {
        const lang = props.languageList.find(l => l.code === currentLanguage);
        return lang?.shortLabel || 'PL';
    };

    return (
        <Tooltip title={t('sidebar.changeLanguage')}>
            <div ref={dropdownRef} style={{ position: 'relative' }}>
                <LanguageSwitcherContainer
                    type="button"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    <GlobeIcon/>
                    <LanguageLabel>{getCurrentLanguageLabel()}</LanguageLabel>
                </LanguageSwitcherContainer>

                {isDropdownOpen && (
                    <LanguageDropdown $isOpen={isDropdownOpen}>
                        {props.languageList.map(lang => (
                            <LanguageOption
                                type="button"
                                key={lang.code}
                                $isActive={currentLanguage === lang.code}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleLanguageChange(lang.code);
                                }}
                            >
                                {lang.label}
                            </LanguageOption>
                        ))}
                    </LanguageDropdown>
                )}
            </div>
        </Tooltip>
    );
};

export default LanguageSwitcher;
